import React from "react";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, A11y, Mousewheel } from "swiper";
import Button from "components/button";
import { formatTitle } from "helpers/format-title";

const settings = {
	modules: [Navigation, A11y, Mousewheel],
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	breakpoints: {
		320: { slidesPerView: 1.2, spaceBetween: 10 },
		768: {
			slidesPerView: 2,
			navigation: { navigation: false },
		},
		1024: {
			slidesPerView: 3,
			navigation: { navigation: false },
		},
	},
	a11y: false,
};

const ThreeColumnsText = ({ data }) => {
	const { data: columns, cta, isSlider, isPicture, title, centerTitle } = data;


	return !isSlider ? (
		<div className="mx-auto w-11/12 py-10">
			<h2 className={`flex items-center justify-center py-2 md:py-4 md:text-h2 ${centerTitle ? "text-center" : ""}`}>
				{formatTitle(title)}
			</h2>
			<div className="flex md:flex-row flex-col">
				{columns?.map((c) => (
					<div key={c._key} className="flex flex-col my-3 mx-auto w-11/12 md:w-1/3 items-center">
						<div className="flex items-center mb-0 flex-col w-full md:w-3/4 flex-shrink-0">
							{c?.icon && <Image className="mb-6" width={isPicture ? 240 : 47} image={c.icon.asset} alt={c.icon.alt} />}
							<h3 className="relative text-center">{formatTitle(c.title)}</h3>
						</div>
						<span className="w-full md:w-3/4 text-center self-center">{c.content}</span>
					</div>
				))}
			</div>
			<Button data={cta} className="mt-10 btn-center" />
		</div>
	) : (
		<div className="w-full px-10 py-5 md:py-10 relative">
			<h2 className="flex items-center justify-center py-4 md:py-8 text-center md:text-h2">{formatTitle(title)}</h2>
			<Swiper {...settings}>
				{columns?.map((c) => (
					<SwiperSlide key={c._key}>
						<div className="flex flex-col">
							<div className="flex items-center mb-4 flex-col w-full md:w-3/4 m-auto">
								<Image className="mb-4" width={isPicture ? 240 : 47} image={c.icon.asset} alt={c.icon.alt} />
								<h3 className="relative bottom-1 text-center mb-1 left-3">{formatTitle(c.title)}</h3>
								<span className="w-full text-sm md:w-3/4 leading-5 text-center self-center">{c.content}</span>
							</div>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
			<Button data={cta} className="mt-4 btn-center" />
		</div>
	);
};

export default ThreeColumnsText;